'use client';
import { useEffect } from 'react';
import {
  BESTSELLERS_EVENT_NAMES,
  bestSellersBusinessLogger,
} from '@/utils/logger/instance/bestSellersBusinessLogger';
export default function Effect({ bannerBackGround }: { bannerBackGround: any }) {
  useEffect(() => {
    if (!bannerBackGround) {
      bestSellersBusinessLogger({
        eventName: BESTSELLERS_EVENT_NAMES.BANNER_IMG_FETCH_FAIL,
        message: {
          error: 'banner server fail',
        },
      });
    }
  }, []);
  return null;
}
